import inventories from "../services/inventories";
import notification from "../services/notification";
import advanceSearchHelper from "../services/advance.search.helper";

export default {
    namespaced: true,
    state: {
        loading: false,
        products: [],
        categories: [],
        productDetails: { // Simple
            product_details: {
                name: "",
                images: [
                    {
                        name: 'first',
                        active: true,
                        action: "create",
                        image_name: "",
                        product_id: "",
                        uuid: "" 
                    }
                ]
            }
        },
        productVariableDetails: { // Variable
            name: "",
            images: [
                {
                    name: 'first',
                    active: true,
                    action: "create",
                    image_name: "",
                    product_id: "",
                    uuid: "" 
                }
            ]
        },
        categoryOptions: [],
        categorySearchOptions: [],
        defaultCategorySearchOption: null,
        defaultSearchableFieldOption: null,
        searchableFields: [],
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        currentPage: 1,
        totalPerPage: 1,
        currentFirstItem: 1,
        currentLastItem: 1,
        initialPageCount: 0,
        errors: null,
        editing: false,
        searchKeyword: null
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        products(state, products) {
            state.products = products;
            state.loading = false;
            state.searching = false;
        },
        categories(state, categories) {
            state.categories = categories;
            state.loading = false;
        },
        categoryOptions(state, categoryOptions) {
            state.categoryOptions = categoryOptions;
            state.loading = false;
        },
        searchableFields(state, fields) {
            state.searchableFields = fields;
            state.defaultSearchableFieldOption = fields[0].value;
        },
        categorySearchOptions(state, options) {
            state.categorySearchOptions = options;
            state.defaultCategorySearchOption = options[0].value;
        },
        defaultCategorySearchOption(state, value) {
            state.defaultCategorySearchOption = value;
        },
        defaultSearchableFieldOption(state, value) {
            state.defaultSearchableFieldOption = value;
        },
        searchKeyword(state, value) {
            state.searchKeyword = value;
        },
        pagination(state, pagination) {
            state.totalPerPage = pagination.list.length;
            state.maxPage = pagination.max_page;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
            state.currentFirstItem =
                state.initialPageCount * state.prevPage + 1;
            state.currentLastItem =
                state.currentFirstItem > 0
                    ? state.currentFirstItem + state.totalPerPage - 1
                    : 0;
        },
        setInitialPageCount(state, list) {
            state.initialPageCount = list.length;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        resetErrors(state) {
            state.errors = null;
        },
        setDetails(state, details) { // Simple
            state.productDetails = details;
        },
        setVariableDetails(state, details) { // Variable
            state.productVariableDetails = details;
        },
        editing(state, value) {
            state.editing = value;
        },
    },
    actions: {
        async resetErrors({ commit }) {
            commit("resetErrors");
        },
        async resetEditing({ commit }) {
            commit("editing", false);
        },
        async editing({ commit }) {
            commit("editing", true);
        },
        async getProducts({ commit }, param) {
            commit("loading");
            try {
                let response = await inventories.getProducts(param);
                let categories = await inventories.getCategories();
                categories = categories.list;

                if (param.page == 1) {
                    await commit("setInitialPageCount", response.list);
                }
                response.list.forEach(function(element) {
                    let category = categories.find(category => category.id === element.product_details.category_id);
                    element.product_details["category_name"] = category.name;
                    element["category_name"] = category.name;
                    if (element.on_sale === 0) {
                        element["_cellVariants"] = { sale_price: "secondary", sale_schedule: "secondary" }
                    } else {
                        var onSaleToDate = new Date(element.on_sale_to);
                        var now = new Date();
                        if (onSaleToDate < now) {
                            element["_cellVariants"] = { sale_price: "secondary" }
                        }
                    }
                    // if (element.stock === 3) {
                    //     element["_cellVariants"] = { stock: "danger" }
                    // }
                    element["product_name"] = element.product_details["name"];
                    element["product_type"] = element.product_details["type"];
                });
                await commit("products", response.list);
                await commit("pagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getCategories({ commit }) {
            commit("loading");
            try {
                let response = await inventories.getCategories();
                commit("categories", response.list);
                commit("categoryOptions", response.list.map(obj =>{ 
                    var rObj = {};
                    rObj["value"] = obj.id;
                    rObj["text"] = obj.name;
                    return rObj;
                }));
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getCategoryOptions({ commit }) {
            try {
                let response = await inventories.getCategoryOptions();
                let categorySearchOptions = advanceSearchHelper.buildOptionFor(response.options, "All Status");
                commit("categorySearchOptions", categorySearchOptions);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async getSearchableFieldsOptions({ commit }) {
            try {
                let response = await inventories.getColumnOptions();
                let columnOptions = advanceSearchHelper.buildOptionFor(response.options, null);
                commit("searchableFields", columnOptions);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async saveSimpleProduct({ commit }, param) {
            commit("loading");
            try {
                let response = await inventories.saveSimpleProduct(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot create new product.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async saveVariableProduct({ commit }, param) {
            commit("loading");
            try {
                let response = await inventories.saveVariableProduct(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot create new product.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async deleteProduct({ commit }, uuid) {
            commit("loading");
            try {
                let response = await inventories.deleteProduct(uuid);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning(errors.errors.message);
                commit("loading", false);
            }
        },
        async viewSimpleProduct({ commit }, uuid) {
            commit("loading");
            let reformattedProductImages = [
                { name: 'first', active: true, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'second', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'third', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'fourth', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'fifth', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'sixth', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'seventh', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'eighth', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'ninth', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'tenth', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
            ];
            try {
                let response = await inventories.viewSimpleProduct(uuid);
                if (response.simple.on_sale !== 0) {
                    response.simple["dateRange"] = response.simple.on_sale_from.slice(0, 10) + ' to ' + response.simple.on_sale_to.slice(0, 10);
                    
                } else {
                    let today = new Date();
                    let dd = String(today.getDate()).padStart(2, '0');
                    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                    let yyyy = today.getFullYear();
                    today = yyyy + '-' + mm + '-' + dd;
                    response.simple["dateRange"] = today + ' to ' + today;
                    response.simple["discount_type"] = "%";
                    response.simple["discount_value"] = 1;
                }
                
                let productImages = response.simple.product_details.images;
                for (let index = 0; index < productImages.length; index++) {
                    reformattedProductImages[index].image_name = productImages[index].image_name;
                    reformattedProductImages[index].product_id = productImages[index].product_id;
                    reformattedProductImages[index].uuid = productImages[index].uuid;
                }
                response.simple.product_details.images = reformattedProductImages;
                
                response.simple.discount_value = Math.trunc(Number.parseFloat(response.simple.discount_value));
                response.simple.regular_price = Number.parseFloat(response.simple.regular_price).toFixed(2);
                response.simple.sale_price = Number.parseFloat(response.simple.sale_price).toFixed(2);
                
                commit("setDetails", response.simple);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async viewVariableProduct({ commit }, uuid) {
            commit("loading");
            let reformattedProductImages = [
                { name: 'first', active: true, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'second', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'third', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'fourth', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'fifth', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'sixth', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'seventh', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'eighth', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'ninth', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
                { name: 'tenth', active: false, action: "create", image_name: "", product_id: "", uuid: "" },
            ];
            try {
                let response = await inventories.viewVariableProduct(uuid);
                console.log(response);
                response.variable.attributes.forEach(function(attribute) {
                    attribute["action"] = "update";
                    attribute.variations.forEach(function(variation) {
                        variation["action"] = "update";
                    });
                });
                let allOnSale = response.variable.inventory.every(product => product.on_sale === 1 && product.discount_type === product.discount_type[0] && product.discount_value === product.discount_value[0]);
                response.variable["allOnSale"] = allOnSale;
                response.variable["allDiscountType"] = "%";
                if (response.variable.inventory.every(product => product.discount_type === "PHP")) {
                    response.variable["allDiscountType"] = "PHP";
                }
                response.variable["allDiscountValue"] = 0;

                let productImages = response.variable.images;
                for (let index = 0; index < productImages.length; index++) {
                    reformattedProductImages[index].image_name = productImages[index].image_name;
                    reformattedProductImages[index].product_id = productImages[index].product_id;
                    reformattedProductImages[index].uuid = productImages[index].uuid;
                }
                response.variable.images = reformattedProductImages;

                if(allOnSale) {
                    response.variable["allDiscountValue"] = Math.trunc(Number.parseFloat(response.variable.inventory[0].discount_value));
                    response.variable["allDateRange"] = response.variable.inventory[0].on_sale_from.slice(0, 10) + ' to ' + response.variable.inventory[0].on_sale_to.slice(0, 10);
                } else {
                    let today = new Date();
                    let dd = String(today.getDate()).padStart(2, '0');
                    let mm = String(today.getMonth() + 1).padStart(2, '0');
                    let yyyy = today.getFullYear();
                    today = yyyy + '-' + mm + '-' + dd;
                    response.variable["allDateRange"] = today + ' to ' + today;
                }
                
                for (let i = 0; i < response.variable.inventory.length; i++) {
                    response.variable.inventory[i].regular_price = Number.parseFloat(response.variable.inventory[i].regular_price).toFixed(2);
                    response.variable.inventory[i].sale_price = Number.parseFloat(response.variable.inventory[i].sale_price).toFixed(2);
                    response.variable.inventory[i].discount_value = Math.trunc(Number.parseFloat(response.variable.inventory[i].discount_value));

                    if (response.variable.inventory[i].on_sale !== 0) {
                        response.variable.inventory[i]["dateRange"] = response.variable.inventory[i].on_sale_from.slice(0, 10) + ' to ' + response.variable.inventory[i].on_sale_to.slice(0, 10);
                        
                    } else {
                        let today = new Date();
                        let dd = String(today.getDate()).padStart(2, '0');
                        let mm = String(today.getMonth() + 1).padStart(2, '0');
                        let yyyy = today.getFullYear();
                        today = yyyy + '-' + mm + '-' + dd;
                        response.variable.inventory[i]["dateRange"] = today + ' to ' + today;
                        response.variable.inventory[i].discount_type = "%";
                        response.variable.inventory[i].discount_value = 0;
                    }

                    let variation_name = "";
                    for (let k = 0; k < response.variable.inventory[i].decoded_variation_code.length; k++) {
                        variation_name += response.variable.inventory[i].decoded_variation_code[k].value + ' - ';
                    }
                    response.variable.inventory[i]["variation_name"] = variation_name.slice(0, -3);
                }
                commit("setVariableDetails", response.variable);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
        async updateSimpleProduct({ commit }, data) {
            commit("loading");
            try {
                let response = await inventories.updateSimpleProduct(
                    data.uuid,
                    data.param
                );
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot update product.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async updateVariableProduct({ commit }, data) {
            commit("loading");
            try {
                let response = await inventories.updateVariableProduct(
                    data.uuid,
                    data.param
                );
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot update product.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async updateVisibilityProduct({ commit }, data) {
            commit("loading");
            try {
                let response = await inventories.updateVisibilityProduct(
                    data.uuid,
                    data.param
                );
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot update package.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
    },
};